import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import OptionalInfoField from './OptionalInfoField';

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  }
};

const TireSetInfo = ({tireSetInfo, children, classes}) => < >
    <form className={classes.container} noValidate autoComplete="off">
      {tireSetInfo.map(t => <OptionalInfoField label={t.label} key={t.label}>{t.value}</OptionalInfoField>)}
    </form>
    {children && <Typography variant="h6" align="center">{children}</Typography>}
  </>;

// @ts-ignore
export default withStyles(styles)(TireSetInfo);

